import { Link } from 'react-router-dom';
import { SEOHead } from '../components/seo/SEOHead';

export default function Terms() {
  return (
    <>
      <SEOHead page="terms" />
      
      <div data-testid="terms-page">
        {/* Hero Section */}
        <section className="bg-[hsl(215,50%,23%)] text-white py-8 md:py-12">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <p className="text-white/70 text-sm uppercase tracking-wide mb-2">Legal</p>
            <h1 className="text-2xl md:text-3xl font-bold mb-2 text-white">Terms & Conditions</h1>
            <p className="text-white/70">Effective Date: January 1, 2026</p>
          </div>
        </section>

      {/* Content */}
      <section className="gov-section bg-white">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="prose max-w-none">
            <div className="gov-panel space-y-8">
              
              <section>
                <h2 className="text-xl font-bold text-[hsl(215,50%,23%)] mb-4">Corporate Information</h2>
                <p className="text-gray-700 mb-4">
                  Canadian Document Services Inc. ("CDS", "we", "us", or "our") is a federally incorporated Canadian company providing private administrative document preparation services.
                </p>
                <div className="bg-[hsl(210,20%,96%)] border border-gray-200 p-4 rounded-sm">
                  <p className="text-gray-700 text-sm">
                    <strong>Registered Office:</strong><br />
                    5000 Yonge St. Suite 1901<br />
                    North York, ON M2N 7E9<br />
                    Canada
                  </p>
                </div>
                <p className="text-gray-700 mt-4">
                  By accessing this website or engaging CDS services, you ("Applicant") agree to be bound by these Terms & Conditions.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-[hsl(215,50%,23%)] mb-4">Nature and Scope of Services</h2>
                <p className="text-gray-700 mb-4">
                  CDS provides administrative preparation and document coordination services relating to:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 mb-4">
                  <li>Record Suspension applications under the Criminal Records Act</li>
                  <li>U.S. Entry Waiver administrative preparation</li>
                  <li>Record Destruction or File Purge requests</li>
                  <li>Passport administrative preparation support</li>
                  <li>Certified criminal record check coordination</li>
                </ul>
                <div className="bg-amber-50 border border-amber-200 p-4 rounded-sm">
                  <p className="text-amber-800 text-sm font-medium">
                    CDS does not provide legal advice and does not act as legal counsel. CDS is not affiliated with any government agency. All approval decisions are made solely by the appropriate government authority.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-bold text-[hsl(215,50%,23%)] mb-4">No Guarantee of Outcome</h2>
                <p className="text-gray-700">
                  CDS does not approve, deny, influence, or control the outcome of any government application. CDS does not guarantee approval, processing timelines, or specific results. Any eligibility discussions provided by CDS are administrative in nature.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-[hsl(215,50%,23%)] mb-4">Fees and Payment</h2>
                <p className="text-gray-700">
                  Service fees charged by CDS relate strictly to administrative preparation, document coordination, and associated processing tasks. Government fees, fingerprinting fees, and third-party charges are separate and payable to the issuing authority.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-[hsl(215,50%,23%)] mb-4">Cancellation Policy</h2>
                <p className="text-gray-700 mb-4">
                  Applicants may cancel services within 48 hours of receiving written file confirmation, provided that no services have commenced. Cancellation requests must be submitted in writing to: processing@canadiandocumentservices.com
                </p>
                <p className="text-gray-700">
                  If services have commenced, administrative fees are non-refundable. Government fees, fingerprinting fees, and third-party disbursements are non-refundable once incurred.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-[hsl(215,50%,23%)] mb-4">Applicant Responsibilities</h2>
                <ul className="list-disc list-inside text-gray-600 space-y-2">
                  <li>Provide accurate, complete, and truthful information</li>
                  <li>Disclose all relevant criminal history and court information</li>
                  <li>Respond to documentation requests promptly</li>
                  <li>Notify CDS of changes in contact information</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-[hsl(215,50%,23%)] mb-4">Limitation of Liability</h2>
                <p className="text-gray-700">
                  To the fullest extent permitted by applicable law, CDS shall not be liable for government decisions, processing delays, or losses resulting from inaccurate information supplied by the Applicant. CDS's total liability shall not exceed the administrative service fees paid by the Applicant.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-[hsl(215,50%,23%)] mb-4">Governing Law</h2>
                <p className="text-gray-700">
                  These Terms & Conditions shall be governed by and interpreted in accordance with the laws of the Province of Ontario and the applicable federal laws of Canada.
                </p>
              </section>

            </div>
          </div>

          {/* Back Link */}
          <div className="mt-8 text-center">
            <Link to="/" className="text-[hsl(210,80%,40%)] hover:text-[hsl(210,80%,30%)] text-sm">
              ← Back to Home
            </Link>
          </div>
        </div>
      </section>
      </div>
    </>
  );
}
